import type { ChartData, NullableFloatArray } from "atoms/Ltool/chartAtoms";
import { isRecord, toNumberOrNull } from "utils/achievementConfigForm";

// 個別描画 GET（achievement_level/<unit>/[<gear>/]<condition>）の `data` を、画面が前提にする形へ正規化する。
// `response.json()` は any で型注釈だけでは形を保証できない。BE 未反映の環境（新キー無し）や
// 想定外の形でも落とさず、補正後設計値は空配列、補正値は未計算（キー無し）として扱う。

type GraphData = ChartData["data"];

const toSeries = (value: unknown): NullableFloatArray =>
    Array.isArray(value) ? value.map(toNumberOrNull) : [];

// 数値に直せないグループは捨てる。1 つも残らなければ未計算と同じくキー無しにする。
const toThreeSigma = (value: unknown): Record<string, number> | undefined => {
    if (!isRecord(value)) return undefined;
    const entries = Object.entries(value).flatMap(([groupId, sigma]): [string, number][] => {
        const parsed = toNumberOrNull(sigma);
        return parsed === null ? [] : [[groupId, parsed]];
    });
    return entries.length > 0 ? Object.fromEntries(entries) : undefined;
};

export const toGraphData = (body: unknown): GraphData => {
    const data = isRecord(body) && isRecord(body.data) ? body.data : {};
    const { measurement_corrected, three_sigma, ...rest } = data;
    const threeSigma = toThreeSigma(three_sigma);
    return {
        target: [],
        measurement: [],
        NG_freq: null,
        ...(rest as Partial<GraphData>),
        measurement_corrected: toSeries(measurement_corrected),
        ...(threeSigma ? { three_sigma: threeSigma } : {}),
    };
};
